// src/pages/PrivacyPolicyPage.jsx

import React from "react";
import "../css/PrivacyPolicyPage.css";

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-page">

  <section className="privacy-hero">
    <div className="hero-overlay"></div>

    <div className="hero-content">
      <span className="hero-badge">Privacy & Security</span>

      <h1>Privacy Policy</h1>

      <p>
        Your privacy matters to us. Learn how Mithralaya collects,
        protects and manages your information.
      </p>

      <div className="last-updated">
        Last Updated • 14 July 2026
      </div>
    </div>
  </section>

    <div className="policy-container">

      <h1 className="policy-title">Privacy Policy</h1>

      <p className="policy-updated">
        <strong>Last Updated:</strong> 14 July 2026
      </p>

      <p>
        Mithralaya respects your privacy and is committed to protecting the
        personal information you share with us. This Privacy Policy explains how
        we collect, use, disclose, and safeguard your information when you
        visit our website, make a purchase, or otherwise interact with us
        (collectively, the "Services").
      </p>

      <p>
        By using our Services, you agree to the terms of this Privacy Policy.
      </p>

      <h2>1. Information We Collect</h2>

      <h3>a) Information You Provide to Us</h3>

      <ul>
        <li>Name</li>
        <li>Email Address</li>
        <li>Phone Number</li>
        <li>Billing & Shipping Address</li>
        <li>Payment Information (processed securely through payment partners)</li>
        <li>Account Login Credentials</li>
        <li>Order History & Shopping Preferences</li>
        <li>Customer Support Communications</li>
      </ul>

      <h3>b) Information Collected Automatically</h3>

      <ul>
        <li>IP Address</li>
        <li>Browser Type & Device Information</li>
        <li>Pages Visited & Time Spent on Website</li>
        <li>Click Behaviour</li>
        <li>Cookies & Tracking Technologies</li>
        <li>Approximate Location based on IP Address</li>
      </ul>

      <h3>c) Information from Third Parties</h3>

      <ul>
        <li>Payment Processors</li>
        <li>Shipping Partners</li>
        <li>Marketing Platforms</li>
        <li>Social Media Platforms (where applicable)</li>
      </ul>

      <h2>2. How We Use Your Information</h2>

      <ul>
        <li>Process and fulfill your orders.</li>
        <li>Communicate order updates and notifications.</li>
        <li>Improve our website and customer experience.</li>
        <li>Personalize your shopping experience.</li>
        <li>Prevent fraud and enhance security.</li>
        <li>Comply with legal obligations.</li>
        <li>Send marketing communications (where permitted).</li>
      </ul>

      <h2>3. Cookies & Tracking Technologies</h2>

      <p>Mithralaya uses cookies and similar technologies to:</p>

      <ul>
        <li>Remember your shopping cart and preferences.</li>
        <li>Analyze website traffic and performance.</li>
        <li>Deliver relevant advertisements.</li>
      </ul>

      <p>
        You can disable cookies through your browser settings. However, some
        website features may not function correctly.
      </p>

      <h2>4. How We Share Your Information</h2>

      <p>
        Mithralaya does <strong>not sell</strong> your personal information.
      </p>

      <p>Your information may be shared with:</p>

      <ul>
        <li>Payment Processors</li>
        <li>Shipping & Courier Partners</li>
        <li>Hosting & IT Service Providers</li>
        <li>Marketing & Analytics Partners (where permitted)</li>
        <li>Legal Authorities (when required by law)</li>
        <li>Business Transfers (merger, acquisition or sale of assets)</li>
      </ul>

      <h2>5. Data Retention</h2>

      <p>
        We retain your personal information only as long as necessary to provide
        our Services, comply with legal obligations, resolve disputes, and
        enforce our agreements.
      </p>

      <h2>6. Your Rights</h2>

      <p>You may have the right to:</p>

      <ul>
        <li>Access your personal information.</li>
        <li>Request corrections to inaccurate data.</li>
        <li>Request deletion of your personal information.</li>
        <li>Opt out of marketing communications.</li>
        <li>Restrict certain processing activities.</li>
        <li>Request data portability.</li>
      </ul>

      <p>
        To exercise any of these rights, please contact us at
        <strong> hello@mithralaya.in</strong>.
      </p>

      <h2>7. Data Security</h2>

      <p>
        We implement reasonable administrative, technical, and physical security
        measures to protect your information. While we strive to protect your
        data, no internet transmission or storage system can be guaranteed to be
        100% secure.
      </p>

      <h2>8. Third-Party Links</h2>

      <p>
        Our website may contain links to third-party websites. Mithralaya is not
        responsible for the privacy practices or content of those websites.
      </p>

      <h2>9. Changes to This Privacy Policy</h2>

      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page along with the updated "Last Updated" date.
      </p>

      <h2>10. Contact Us</h2>

      <p><strong>Mithralaya</strong></p>

      <p>
        Email:
        <a href="mailto:hello@mithralaya.in"> hello@mithralaya.in</a>
      </p>

      <p>
        Phone:
        <a href="tel:9043902239"> 9043902239</a>
      </p>

      <h2>Consent</h2>

      <p>
        By using the Mithralaya website and Services, you consent to the
        collection and use of your information as described in this Privacy
        Policy.
      </p>

    </div>
    </div>
  );
};

export default PrivacyPolicyPage;